"use client";

import viugoTipsAiSparkle from "@/assets/images/viugo/kbv-v16-tips-ai-sparkle.svg";
import viugoOtherBetsFootball from "@/assets/images/viugo/kbv-v16-other-bets-football.svg";
import viugoChevronUpDown from "@/assets/images/viugo/kbv-v16-chevron-up-down.svg";
import viugoChevronUpDownBlue from "@/assets/images/viugo/kbv-v16-chevron-up-down-blue.svg";
import ViuGoBetPromoSvg from "./ViuGoBetPromoSvg";

export default function ViuGoOddsMatchRowFooter({
    footerBottomWhenLastClass,
    onOpenTipsAiModal,
    onOtherOddsClick,
    otherCount,
    isLive,
    betFilterId,
    betGradientPrimaryId,
    betGradientTextId,
    betGradientBodyId,
    betGradientCircleId,
    betPromoSvgText,
}) {
    return (
        <div className="-mb-px flex w-full text-center font-bold">
            <div
                className={`flex md:w-[31.44%] shrink-0 items-center justify-center text-left [border-right:1px_solid_var(--theme-border)] py-2 md:py-[10px] [&>*]:pl-[10px] ${footerBottomWhenLastClass}`}
            >
                <div className="flex w-full min-w-0 items-center justify-start gap-2 px-[10px] text-[12px] leading-[15px]">
                    <button
                        type="button"
                        onClick={onOpenTipsAiModal}
                        className="kbv-tips-btn-indigo-slate relative flex h-[26px] w-max max-w-full shrink-0 cursor-pointer items-center justify-center gap-0.5 whitespace-nowrap rounded-[8px] border border-solid p-[3px] text-[11px] font-medium leading-[15px] text-white max-lg:w-max lg:h-auto lg:gap-1 lg:px-3 lg:py-2 lg:text-[12px]"
                    >
                        <img
                            src={viugoTipsAiSparkle}
                            alt=""
                            width={16}
                            height={16}
                            className="h-3.5 w-3.5 shrink-0 lg:h-4 lg:w-4"
                            aria-hidden
                        />
                        <div>Tips AI</div>
                    </button>
                </div>
            </div>

            <div
                className={`flex min-w-0 flex-1 items-center justify-center px-1 md:w-[calc((55%/6)*5+1px)] md:flex-none md:shrink-0 md:px-0 py-2 md:py-[10px] ${footerBottomWhenLastClass}`}
            >
                <button
                    type="button"
                    onClick={onOtherOddsClick}
                    className="kbv-shadow-subtle-indigo-slate kbv-bg-betorder-indigo-slate kbv-text-black-odds-indigo-slate box-border flex h-[31px] min-h-[31px] w-full min-w-0 cursor-pointer items-center justify-center gap-0.5 rounded-lg border border-solid px-0.5 py-0 text-[12px] font-normal leading-normal tracking-normal transition duration-200 [border-color:var(--theme-border)] md:hidden [&_img]:transition [&_img]:duration-200"
                >
                    <img
                        src={viugoOtherBetsFootball}
                        alt=""
                        width={16}
                        height={16}
                        className="shrink-0"
                        aria-hidden
                    />
                    <span className="kbv-text-black-odds-indigo-slate min-w-0 shrink font-normal">
                        Kèo khác
                    </span>
                    <span className="kbv-bg-danger-indigo-slate flex shrink-0 flex-col items-center justify-center gap-[10px] rounded p-[2px] text-[11px] font-medium leading-none text-white">
                        {`+${otherCount}`}
                    </span>
                    <img
                        src={viugoChevronUpDown}
                        alt=""
                        width={16}
                        height={16}
                        className="ml-0.5 shrink-0"
                        aria-hidden
                    />
                </button>
                <div
                    className="group hidden w-[160px] cursor-pointer select-none items-center justify-center gap-[10px] rounded-[4px] border border-solid border-[var(--theme-highlight)] p-[5px] text-[12px] font-medium text-[var(--theme-highlight)] transition md:flex hover:bg-[var(--theme-highlight)] hover:text-white [&>img]:transition [&>img]:duration-200"
                    onClick={onOtherOddsClick}
                >
                    <div>
                        Xem thêm các <span>{`(+${otherCount})`}</span> loại cược khác
                    </div>
                    <img
                        src={viugoChevronUpDownBlue}
                        alt=""
                        width={20}
                        height={20}
                        className="shrink-0 group-hover:brightness-0 group-hover:invert"
                        aria-hidden
                    />
                </div>
            </div>

            <div
                className={`flex min-w-0 flex-1 basis-0 items-center justify-center gap-1 px-1 py-0 md:px-2 md:py-1 ${footerBottomWhenLastClass}`}
            >
                <div className="relative flex max-w-full items-center gap-[10px] bg-contain bg-center bg-no-repeat p-0 font-normal">
                    {!isLive && (
                        <ViuGoBetPromoSvg
                            betFilterId={betFilterId}
                            betGradientPrimaryId={betGradientPrimaryId}
                            betGradientTextId={betGradientTextId}
                            betGradientBodyId={betGradientBodyId}
                            betGradientCircleId={betGradientCircleId}
                            betPromoSvgText={betPromoSvgText}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}
